// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums / Interfaces
import { ScatterPlotPresentationOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// NgRx actions / selectors
import { setPresentationOption } from './presentation-options.actions';
import { setScatterPlot } from '../scatter-plot.actions';
export const note = createReducer('', on(setPresentationOption, (state, action) => {
    if (action.option === ScatterPlotPresentationOptionValue.note) {
        return action.value;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.note;
}));
